import { useState, useEffect } from 'react';
import { getTenantInfo } from '../api';

export default function useTenant(slug) {
  const [tenant, setTenant] = useState(null);
  const [error,  setError]  = useState(null);

  useEffect(() => {
    if (!slug) return;
    getTenantInfo(slug)
      .then(setTenant)
      .catch(() => setError('Business not found. Please check the booking link.'));
  }, [slug]);

  return { tenant, error };
}
